export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";